import * as React from "react"
import {Skeleton} from "@mui/material";

import { TitleWithPopover, AppTableSeeker } from "@components";
import {useToast} from "@hooks";
import {isLoadingCommonFilters} from "@signals";
import {useProductPageDetailsSearch, useProductPageDetailsRoleConfig} from "../@hooks";
import {checkColumn, imageSkuColumn, lastReviewColumn, numberColumn, retailerColumn, skuColumn, stockColumn, sellerColumn, stringColumn, dateColumn} from "./columns";
import CreateReportButton from "./actions/CreateReportButton"


export default function DigitalShelfProductPagesTable() {
	const { showToast } = useToast()
	const { data, kpiConfig } = useProductPageDetailsSearch()
	const { isMarketplacesUser, urlApiExcel } = useProductPageDetailsRoleConfig()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
	if (!data.length) return <></>

	
	const columnGenerators = {
		check: (name, label, visibility) => checkColumn(name, label, visibility),
		number: (name, label, visibility, decimals) => numberColumn(name, label, visibility, decimals),
		lastReview: () => lastReviewColumn(),
		date: (name, label, visibility) => dateColumn(name, label, visibility),
		stock: (name, label, visibility) => stockColumn(name, label, visibility),
		string: (name, label, visibility) => stringColumn(name, label, visibility)
	}

	const columns = [
		imageSkuColumn(),
		...skuColumn(),
		...retailerColumn(),
		...(isMarketplacesUser ? [...sellerColumn()] : [])
	]

	kpiConfig.forEach(({ name, label, type, decimals, visibility=true, condition = true }) => {
		if (!condition) return
		const generator = columnGenerators[type]
		if (generator) {
			columns.push(...generator(name, label, visibility, decimals))
		}
	})

	return <AppTableSeeker
		data={data}
		title={<TitleWithPopover title="Product Display Analyzer" />}
		columns={columns}
		options={{
			onDownload: () => showToast.promiseExcel(urlApiExcel),
			customToolbar: () => <CreateReportButton />
		}}
	/>
}